import React from 'react';
import { SpacingStack, TextV2 } from '@withjoy/joykit';
import { StyledCountdownGiftCountContainer, StyledArea, styles } from './CountdownGiftCount.styles';
import { useTranslation } from '@shared/core';
import { SkeletonText, SkeletonGroup, Skeleton } from '@shared/components/Skeleton';
import { pxToRem } from '@withjoy/joykit/theme';
import { GiftCountControllerProps, useCountdownGiftCountController } from './CountdownGiftCount.controller';

export const CountdownGiftCount: React.FC<GiftCountControllerProps> = ({ eventHandle, onGiftTypeClick }) => {
  const { countDownValue, available, purchased, countDownValueLoading, handleOnGiftTypeClick } = useCountdownGiftCountController({ eventHandle, onGiftTypeClick });
  const { t2 } = useTranslation('sharedComponents');
  const {
    counters: { giftsAddedLabel, reservedAndPurchaseLabel }
  } = t2('countdownGiftCount');

  return (
    <StyledCountdownGiftCountContainer __css={styles.countdownGiftCountContainer}>
      <StyledArea __css={styles.countdownArea} data-area="countdown">
        <SkeletonGroup isReady={!countDownValueLoading} placeholder={<SkeletonText marginTop={5} rows={1} width={pxToRem(170)} height={pxToRem(26)} />}>
          <TextV2 typographyVariant="hed4">{countDownValue}</TextV2>
        </SkeletonGroup>
      </StyledArea>
      <StyledArea __css={styles.availableArea} data-area="available" onClick={handleOnGiftTypeClick}>
        <SkeletonGroup
          isReady={!countDownValueLoading}
          placeholder={
            <SpacingStack spacing={3} alignItems="center">
              <Skeleton width={pxToRem(50)} height={pxToRem(48)} />
              <Skeleton width={pxToRem(105)} height={pxToRem(21)} />
            </SpacingStack>
          }
          __css={styles.skeletonGroup}
        >
          <TextV2 fontSize={40} lineHeight={pxToRem(48)} color="linkText" width="100%" textAlign="center">
            {available}
          </TextV2>
          <TextV2 typographyVariant="hed1" textAlign="center" maxWidth={100}>
            {giftsAddedLabel}
          </TextV2>
        </SkeletonGroup>
      </StyledArea>
      <StyledArea __css={styles.purchasedArea} data-area="purchased" onClick={handleOnGiftTypeClick}>
        <SkeletonGroup
          isReady={!countDownValueLoading}
          placeholder={
            <SpacingStack spacing={3} alignItems="center">
              <Skeleton width={pxToRem(50)} height={pxToRem(48)} />
              <Skeleton width={pxToRem(105)} height={pxToRem(21)} />
            </SpacingStack>
          }
          __css={styles.skeletonGroup}
        >
          <TextV2 fontSize={40} lineHeight={pxToRem(48)} color="linkText" width="100%" textAlign="center">
            {purchased}
          </TextV2>
          <TextV2 typographyVariant="hed1" textAlign="center" maxWidth={100}>
            {reservedAndPurchaseLabel}
          </TextV2>
        </SkeletonGroup>
      </StyledArea>
    </StyledCountdownGiftCountContainer>
  );
};
